<div class="flex flex-col relative gap-[var(--gap-small)]">
  <form [formGroup]="form">
    <so-input-ui
      class="w-full"
      [formControlName]="'prompt'"
      [label]="$label() ?? ''" [placeholder]="$placeholder()"
      [isTextarea]="true"
      [rows]="3"
      [isDisabled]="$processing()"
      [suggestions]="$suggestions()"
      [enableVirtualScroll]="$suggestions().length > 0"
      [virtualScrollItemSize]="36"
      [virtualScrollMaxHeight]="220"
      [showNoSuggestionsMessage]="false"
      [autocomplete]="'on'"
      (valueChanged)="onStrValueChange($event)"
    />
  </form>
  <so-button-gradient-ui
    class="self-end"
    [variant]="'solid'"
    [color]="'secondary'"
    [text]="$buttonText()"
    [disabled]="($disabled() ?? false) || $processing() || $_value().trim() === '' || $_value().trim().length < $minPromptLength()"
    (clicked)="onButtonClicked()"
  />
  @if ($processing() && false) {
  <so-ai-loader-ui
    class="cursor-progress absolute top-[50%] left-[50%] -translate-x-[50%] -translate-y-[60.5%]"
    [text]="$aiLoaderText()"
  />
  }
</div>
